import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [], // raw data
  loading: false,
  error: null,
};

const loanProductSlice = createSlice({
  name: "loanProduct",
  initialState,
  reducers: {
    fetchLoanProducts: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLoanProductsSuccess: (state, action) => {
      state.loading = false;
      state.products = action.payload; // raw API data
    },
    fetchLoanProductsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchLoanProducts,
  fetchLoanProductsSuccess,
  fetchLoanProductsFailure,
} = loanProductSlice.actions;

export default loanProductSlice.reducer;
